const getSlottedContent = (slot) => {
    let slottedContentElement = null;
    if (slot) {
        while (!slottedContentElement || slottedContentElement.nodeName === 'SLOT') {
            if (slot.assignedElements().length) {
                if (slot.assignedElements()[0].nodeName === 'SLOT') {
                    slot = slot.assignedElements()[0];
                }
                else {
                    // eslint-disable-next-line prefer-destructuring
                    slottedContentElement = slot.assignedElements()[0];
                }
            }
            else {
                break;
            }
        }
    }
    return slottedContentElement;
};

export { getSlottedContent as g };
